import {
  getBrowserAnalyticsClient,
  initBrowserAnalytics,
} from "@workspace/analytics/browser";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import type * as React from "react";

if (typeof window !== "undefined") {
  initBrowserAnalytics({
    apiHost: "https://t.vacwork.app",
    debug: process.env.NODE_ENV === "development",
    host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    key: process.env.NEXT_PUBLIC_POSTHOG_KEY as string,
  });
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return (
    <PHProvider client={getBrowserAnalyticsClient()}>{children}</PHProvider>
  );
}
